import { Facebook, PenLine, Quote } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { REVIEWS, FB_REVIEWS_URL } from "../config/site";

const PLACEHOLDERS = [1, 2, 3];

export const Reviews = () => (
    <section id="opinie" data-testid="testimonials-section" className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                kicker="Opinie"
                title="Nauczycielki wracają do naszych szkoleń, bo dostają rozwiązania, które mogą naprawdę wykorzystać"
            />

            <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                {REVIEWS.length > 0
                    ? REVIEWS.map((r, i) => (
                          <Reveal key={i} delay={i * 0.08}>
                              <figure
                                  data-testid={`review-card-${i + 1}`}
                                  className="h-full rounded-2xl bg-white border border-border p-7 shadow-soft flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-card"
                              >
                                  <Quote className="w-7 h-7 text-ink" />
                                  <blockquote className="mt-4 text-[15px] text-ink-soft leading-relaxed flex-1">
                                      „{r.quote}”
                                  </blockquote>
                                  <figcaption className="mt-5 border-t border-border pt-4">
                                      <p className="font-display uppercase font-bold text-sm text-ink">
                                          {r.author}
                                      </p>
                                      <p className="text-xs text-ink-mute mt-0.5">
                                          opinia o szkoleniach EduNation
                                      </p>
                                  </figcaption>
                              </figure>
                          </Reveal>
                      ))
                    : PLACEHOLDERS.map((n, i) => (
                          <Reveal key={n} delay={i * 0.08}>
                              <figure
                                  data-testid={`review-placeholder-${n}`}
                                  className="h-full rounded-2xl border-2 border-dashed border-ink/15 bg-cream-deep p-7 flex flex-col items-start justify-center min-h-[220px]"
                              >
                                  <PenLine className="w-6 h-6 text-ink-mute" />
                                  <p className="mt-4 font-display font-semibold text-ink">
                                      Miejsce na opinię uczestniczki
                                  </p>
                                  <p className="mt-2 text-sm text-ink-mute leading-relaxed">
                                      Tu trafi prawdziwy cytat z Facebooka EduNation - wystarczy
                                      uzupełnić listę opinii w konfiguracji strony.
                                  </p>
                              </figure>
                          </Reveal>
                      ))}
            </div>

            <Reveal delay={0.15}>
                <div className="mt-10 flex justify-center">
                    <a
                        data-testid="reviews-facebook-link"
                        href={FB_REVIEWS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 rounded-full border-2 border-ink text-ink hover:bg-ink hover:text-white font-bold px-6 min-h-[48px] text-sm transition-colors duration-300"
                    >
                        <Facebook className="w-4 h-4" />
                        Zobacz wszystkie opinie na Facebooku
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
